/**
 * Component for our Report showing all Return Reasons
 * grouped by Product-Count for recent Returns.
 * 
 * @component
 */

import React from "react";
import Report from "../Report";

const columns = [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName"
  },
  {
    title: "Reason",
    dataIndex: "returnReason",
    key: "returnReason"
  },
  {
    title: "Count",
    dataIndex: "productCount",
    key: "productCount"
  },
];

const exportHeaders = [
  {
    label: "Product Name",
    value: "productName",
  },
  {
    label: "Reason",
    value: "returnReason",
  },
  {
    label: "Count",
    value: "productCount",
  },
];

class ByProduct extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Report
        url="/api/reports/reasons/by-product"
        title="Top Reasons by Product"
        tooltip="This report shows how many times a product was returned for the same reason within the selected date range."
        columns={columns}
        reportName="reasons-by-product"
        exportHeaders={exportHeaders}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        updateDate={this.props.updateDate}
      />
    );
  }
}

export default ByProduct;
